import styles from './Logout.module.scss';
import WithDevice from '../WithDevice/WithDevice';
import { Label } from '../Label/Label';
import { HEADER_LABEL_KEYS } from '../../../lib/constants/labelKeys';
import MenuItem from './MenuItem';
import SubItem from './SubItem';
import { msalInstance } from '../../../lib/utils/auth/msal';

const LogoutItem = () => {
  const logout = async () => {
    await msalInstance.logoutRedirect({});
  };

  return (
    <>
      <WithDevice desktop>
        <SubItem label={<Label name={HEADER_LABEL_KEYS.PROFILE_MENU_LOGOUT_LABEL} />} link="#logout" onClick={logout} />
      </WithDevice>
      <WithDevice mobile tablet>
        <MenuItem
          className={styles.logoutMobileItem}
          label={<Label className={styles.mobileLink} name={HEADER_LABEL_KEYS.PROFILE_MENU_LOGOUT_LABEL} />}
          link="#logout"
          onClick={logout}
        />
      </WithDevice>
    </>
  );
};

export default LogoutItem;
